// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.all-orders-page {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.orders-list-modal {
  background-color: white;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.orders-list-modal h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
}


.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.stat-card {
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  transition: transform 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-card.total {
  background: linear-gradient(135deg, #2196f3, #1976d2);
  color: white;
}

.stat-card.sum {
  background: linear-gradient(135deg, #e91e63, #c2185b);
  color: white;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 5px;
}


.filters-panel {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 25px;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-group label {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  font-weight: 500;
}

.filter-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.filter-input-wrapper .filter-icon {
  position: absolute;
  left: 10px;
  color: #999;
  font-size: 16px;
}

.filter-input-wrapper input {
  width: 100%;
  padding: 10px 30px 10px 35px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.filter-input-wrapper input:focus {
  outline: none;
  border-color: #edec5b;
}

.filter-clear-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.filter-clear-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.filter-group select,
.filter-group input[type="date"] {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  transition: border-color 0.2s;
}

.filter-group select:focus,
.filter-group input[type="date"]:focus {
  outline: none;
  border-color: #edec5b;
}

.filter-actions {
  justify-content: flex-end;
}

.clear-filters-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
}

.clear-filters-btn:hover {
  background: #c82333;
}


.orders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.order-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
}

.order-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.order-card.draft {
  border-left: 4px solid #ffc107;
}

.order-card.confirmed {
  border-left: 4px solid #28a745;
}

.order-card.archived {
  border-left: 4px solid #6c757d;
  opacity: 0.8;
}

.order-card-header {
  background-color: #f8f9fa;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
}

.order-number {
  font-weight: 600;
  color: #333;
}

.order-status {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.order-status.draft {
  background-color: #fff3cd;
  color: #856404;
}

.order-status.confirmed {
  background-color: #d4edda;
  color: #155724;
}

.order-status.archived {
  background-color: #e2e3e5;
  color: #383d41;
}

.order-card-body {
  padding: 15px;
}

.order-card-body div {
  margin-bottom: 6px;
  color: #333;
  font-size: 14px;
}

.order-card-actions {
  padding: 12px 15px;
  display: flex;
  gap: 8px;
  border-top: 1px solid #e9ecef;
}

.order-card-actions button {
  flex: 1 1;
  padding: 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.order-card-actions button:first-child {
  background-color: #edec5b;
  color: rgb(0, 0, 0);
}

.order-card-actions button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.no-orders {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-style: italic;
}


.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 25px;
  flex-wrap: wrap;
}

.pagination button {
  padding: 8px 14px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
}

.pagination button:hover:not(:disabled) {
  background: #edec5b;
  color: #333;
  border-color: #edec5b;
}

.pagination button.active {
  background: #edec5b;
  color: #333;
  border-color: #edec5b;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.confirm-dialog {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 800px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.confirm-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  background-color: white;
  flex-shrink: 0;
}

.confirm-dialog-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.confirm-dialog-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.confirm-dialog-close:hover {
  color: #dc3545;
  background-color: #f8f9fa;
}

.confirm-dialog-message {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
  max-height: calc(85vh - 120px);
}

.confirm-dialog-message::-webkit-scrollbar {
  width: 6px;
}

.confirm-dialog-message::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.confirm-dialog-message::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.confirm-dialog-message::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}


.order-info-section {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.order-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e9ecef;
}

.order-info-row:last-child {
  border-bottom: none;
}

.order-info-row .info-label {
  font-weight: 500;
  color: #666;
}

.order-info-row .info-value {
  font-weight: 600;
  color: #333;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.draft {
  background: #fff3cd;
  color: #856404;
}

.status-badge.confirmed {
  background: #d4edda;
  color: #155724;
}

.status-badge.archived {
  background: #e2e3e5;
  color: #383d41;
}


.order-items-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.items-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 15px;
  padding-right: 5px;
}

.items-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.items-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.items-scroll-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.order-item-detail-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.order-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #f8f9fa;
  cursor: pointer;
  transition: background 0.2s;
}

.order-item-header:hover {
  background: #e9ecef;
}

.order-item-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.item-number {
  background: #edec5b;
  color: #333;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.item-system {
  font-weight: 600;
  color: #333;
}

.item-color {
  font-weight: normal;
  color: #666;
  margin-left: 4px;
}

.order-item-summary {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.item-quantity {
  color: #666;
  font-size: 13px;
}

.item-sum {
  font-weight: 700;
  color: #030303;
  font-size: 14px;
}

.expand-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  padding: 4px;
}

.order-item-details {
  padding: 15px;
  border-top: 1px solid #e9ecef;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 12px;
  color: #666;
}

.detail-value {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.total-row .detail-value {
  font-weight: 700;
  color: #050505;
}

.total-value {
  font-size: 16px;
}


.accessories-section {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 10px;
  margin: 10px 0;
}

.accessories-title {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;
}

.accessory-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 12px;
}

.accessory-name {
  flex: 2 1;
  color: #f8f6f6;
}

.accessory-quantity {
  flex: 0.5 1;
  text-align: center;
  color: #fcfbfb;
}

.accessory-name-m {
  flex: 2 1;
  color: #000000;
}

.accessory-quantity-m {
  flex: 0.5 1;
  text-align: center;
  color: #0a0a0a;
}

.accessory-sum {
  flex: 0.8 1;
  text-align: right;
  font-weight: 500;
  color: #333;
}

.accessories-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #ddd;
  font-weight: 600;
  font-size: 12px;
}

.item-notes-section {
  margin-top: 10px;
  padding: 8px;
  background: #fff3cd;
  border-radius: 4px;
  font-size: 12px;
}

.notes-label {
  font-weight: 600;
  color: #856404;
  margin-right: 8px;
}

.notes-value {
  color: #856404;
}


.order-total-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 2px solid #e9ecef;
}

.total-row.final {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #0b0b0b;
}

.order-notes-section {
  margin-top: 15px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.order-notes-section .notes-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.order-notes-section .notes-value {
  color: #555;
  white-space: pre-wrap;
}


@media (max-width: 768px) {
  .orders-grid {
    grid-template-columns: 1fr;
  }
  
  .filters-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-container {
    grid-template-columns: 1fr;
  }
  
  .confirm-dialog {
    width: 95%;
    max-height: 90vh;
  }
  
  .order-item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .order-item-summary {
    width: 100%;
    justify-content: space-between;
  }
}



.sorting-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  flex-wrap: wrap;
  gap: 10px;
}

.sorting-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sorting-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.sort-icon {
  font-size: 20px;
  color: #6c757d;
}

.sort-select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 200px;
  outline: none;
  transition: border-color 0.2s;
}

.sort-select:hover,
.sort-select:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.sorting-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.filtered-count {
  font-size: 14px;
  color: #6c757d;
}

.filtered-count strong {
  color: #333;
  font-weight: 600;
}

.sort-info {
  font-size: 13px;
  color: #6c757d;
  background: #e9ecef;
  padding: 4px 12px;
  border-radius: 12px;
}

.order-time {
  font-size: 12px;
  color: #6c757d;
  margin-left: 5px;
}


@media (max-width: 768px) {
  .sorting-panel {
    flex-direction: column;
    align-items: stretch;
  }
  
  .sorting-group {
    flex-wrap: wrap;
  }
  
  .sort-select {
    min-width: 100%;
  }
  
  .sorting-info {
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/covfile/AllOrdersPage.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,WAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["\r\n.all-orders-page {\r\n  padding: 20px;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.orders-list-modal {\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  padding: 25px;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.orders-list-modal h2 {\r\n  margin-top: 0;\r\n  margin-bottom: 20px;\r\n  color: #333;\r\n  font-size: 24px;\r\n}\r\n\r\n\r\n.stats-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 15px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.stat-card {\r\n  border-radius: 10px;\r\n  padding: 15px;\r\n  text-align: center;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.stat-card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.stat-card.total {\r\n  background: linear-gradient(135deg, #2196f3, #1976d2);\r\n  color: white;\r\n}\r\n\r\n.stat-card.sum {\r\n  background: linear-gradient(135deg, #e91e63, #c2185b);\r\n  color: white;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 12px;\r\n  opacity: 0.9;\r\n  margin-top: 5px;\r\n}\r\n\r\n\r\n.filters-panel {\r\n  background: #f8f9fa;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.filters-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 15px;\r\n  align-items: end;\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.filter-group label {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 5px;\r\n  font-weight: 500;\r\n}\r\n\r\n.filter-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.filter-input-wrapper .filter-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  color: #999;\r\n  font-size: 16px;\r\n}\r\n\r\n.filter-input-wrapper input {\r\n  width: 100%;\r\n  padding: 10px 30px 10px 35px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.filter-input-wrapper input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.filter-clear-btn {\r\n  position: absolute;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #999;\r\n  font-size: 14px;\r\n  padding: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n}\r\n\r\n.filter-clear-btn:hover {\r\n  background: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n.filter-group select,\r\n.filter-group input[type=\"date\"] {\r\n  padding: 10px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  background: white;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.filter-group select:focus,\r\n.filter-group input[type=\"date\"]:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.filter-actions {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.clear-filters-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.clear-filters-btn:hover {\r\n  background: #c82333;\r\n}\r\n\r\n\r\n.orders-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.order-card {\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.order-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}\r\n\r\n.order-card.draft {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n\r\n.order-card.confirmed {\r\n  border-left: 4px solid #28a745;\r\n}\r\n\r\n.order-card.archived {\r\n  border-left: 4px solid #6c757d;\r\n  opacity: 0.8;\r\n}\r\n\r\n.order-card-header {\r\n  background-color: #f8f9fa;\r\n  padding: 12px 15px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.order-number {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.order-status {\r\n  font-size: 12px;\r\n  padding: 3px 8px;\r\n  border-radius: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.order-status.draft {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.order-status.confirmed {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.order-status.archived {\r\n  background-color: #e2e3e5;\r\n  color: #383d41;\r\n}\r\n\r\n.order-card-body {\r\n  padding: 15px;\r\n}\r\n\r\n.order-card-body div {\r\n  margin-bottom: 6px;\r\n  color: #333;\r\n  font-size: 14px;\r\n}\r\n\r\n.order-card-actions {\r\n  padding: 12px 15px;\r\n  display: flex;\r\n  gap: 8px;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.order-card-actions button {\r\n  flex: 1;\r\n  padding: 6px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.order-card-actions button:first-child {\r\n  background-color: #edec5b;\r\n  color: rgb(0, 0, 0);\r\n}\r\n\r\n.order-card-actions button:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.no-orders {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 25px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pagination button {\r\n  padding: 8px 14px;\r\n  border: 1px solid #ddd;\r\n  background: white;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-size: 14px;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  background: #edec5b;\r\n  color: #333;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.pagination button.active {\r\n  background: #edec5b;\r\n  color: #333;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n.confirm-dialog-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1100;\r\n}\r\n\r\n.confirm-dialog {\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 85vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.confirm-dialog-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid #e9ecef;\r\n  background-color: white;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.confirm-dialog-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.confirm-dialog-close {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #999;\r\n  transition: color 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.confirm-dialog-close:hover {\r\n  color: #dc3545;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.confirm-dialog-message {\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  max-height: calc(85vh - 120px);\r\n}\r\n\r\n.confirm-dialog-message::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.confirm-dialog-message::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.confirm-dialog-message::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.confirm-dialog-message::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n\r\n.order-info-section {\r\n  background: #f8f9fa;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.order-info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.order-info-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.order-info-row .info-label {\r\n  font-weight: 500;\r\n  color: #666;\r\n}\r\n\r\n.order-info-row .info-value {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.draft {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.confirmed {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.archived {\r\n  background: #e2e3e5;\r\n  color: #383d41;\r\n}\r\n\r\n\r\n.order-items-section h4 {\r\n  margin: 0 0 15px 0;\r\n  color: #333;\r\n  font-size: 16px;\r\n}\r\n\r\n.items-scroll-container {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  margin-bottom: 15px;\r\n  padding-right: 5px;\r\n}\r\n\r\n.items-scroll-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.items-scroll-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.items-scroll-container::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.order-item-detail-card {\r\n  background: white;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 8px;\r\n  margin-bottom: 12px;\r\n  overflow: hidden;\r\n}\r\n\r\n.order-item-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 15px;\r\n  background: #f8f9fa;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.order-item-header:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.order-item-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.item-number {\r\n  background: #edec5b;\r\n  color: #333;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.item-system {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.item-color {\r\n  font-weight: normal;\r\n  color: #666;\r\n  margin-left: 4px;\r\n}\r\n\r\n.order-item-summary {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.item-quantity {\r\n  color: #666;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-sum {\r\n  font-weight: 700;\r\n  color: #030303;\r\n  font-size: 14px;\r\n}\r\n\r\n.expand-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #666;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px;\r\n}\r\n\r\n.order-item-details {\r\n  padding: 15px;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.detail-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.detail-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.detail-value {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.total-row .detail-value {\r\n  font-weight: 700;\r\n  color: #050505;\r\n}\r\n\r\n.total-value {\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n.accessories-section {\r\n  background: #f5f5f5;\r\n  border-radius: 6px;\r\n  padding: 10px;\r\n  margin: 10px 0;\r\n}\r\n\r\n.accessories-title {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 5px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.accessory-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 4px 0;\r\n  font-size: 12px;\r\n}\r\n\r\n.accessory-name {\r\n  flex: 2;\r\n  color: #f8f6f6;\r\n}\r\n\r\n.accessory-quantity {\r\n  flex: 0.5;\r\n  text-align: center;\r\n  color: #fcfbfb;\r\n}\r\n\r\n.accessory-name-m {\r\n  flex: 2;\r\n  color: #000000;\r\n}\r\n\r\n.accessory-quantity-m {\r\n  flex: 0.5;\r\n  text-align: center;\r\n  color: #0a0a0a;\r\n}\r\n\r\n.accessory-sum {\r\n  flex: 0.8;\r\n  text-align: right;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.accessories-total {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n  padding-top: 6px;\r\n  border-top: 1px solid #ddd;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.item-notes-section {\r\n  margin-top: 10px;\r\n  padding: 8px;\r\n  background: #fff3cd;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.notes-label {\r\n  font-weight: 600;\r\n  color: #856404;\r\n  margin-right: 8px;\r\n}\r\n\r\n.notes-value {\r\n  color: #856404;\r\n}\r\n\r\n\r\n.order-total-section {\r\n  margin-top: 20px;\r\n  padding-top: 15px;\r\n  border-top: 2px solid #e9ecef;\r\n}\r\n\r\n.total-row.final {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #0b0b0b;\r\n}\r\n\r\n.order-notes-section {\r\n  margin-top: 15px;\r\n  padding: 12px;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n}\r\n\r\n.order-notes-section .notes-label {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.order-notes-section .notes-value {\r\n  color: #555;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .orders-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .filters-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .stats-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .confirm-dialog {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n  \r\n  .order-item-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .order-item-summary {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n\r\n\r\n.sorting-panel {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #e9ecef;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n.sorting-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.sorting-group label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.sort-icon {\r\n  font-size: 20px;\r\n  color: #6c757d;\r\n}\r\n\r\n.sort-select {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 6px;\r\n  background: white;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  min-width: 200px;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.sort-select:hover,\r\n.sort-select:focus {\r\n  border-color: #80bdff;\r\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n.sorting-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.filtered-count {\r\n  font-size: 14px;\r\n  color: #6c757d;\r\n}\r\n\r\n.filtered-count strong {\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.sort-info {\r\n  font-size: 13px;\r\n  color: #6c757d;\r\n  background: #e9ecef;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.order-time {\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  margin-left: 5px;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .sorting-panel {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .sorting-group {\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .sort-select {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .sorting-info {\r\n    justify-content: space-between;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
